<template>
	<div>管理画面</div>
</template>

<script>

export default {
	components: {
	},
	computed: {
	},
	data() {
		return {
		};
	},
};
</script>
